import { useState, useEffect, useCallback } from 'react'
import { useFormState } from 'hooks/useFormState'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useExameNecroscopicoService } from 'hooks/useExameNecroscopicoService'
import { useCadaverService } from 'hooks/useCadaverService'
import useRouter from 'utils/useRouter'

const schemaCaracteristicas = {
  altura: {
    presence: { allowEmpty: false, message: '^Altura é obrigatório' },
  },
  vestimentas: {
    presence: { allowEmpty: false, message: '^Vestimentas é obrigatório' },
  },
}

const getSteps = () => [
  'Características',
  'Tatuagens e cicatrizes',
  'Fenômenos cadavéricos',
  'Lesões',
  'Análises Internas',
  'Discussão e Conclusão',
  'Quesitos'
]


export const useExameNecroscopicoForm = (exameNecroscopico, setExameNecroscopico) => {
  const router = useRouter()
  const exameNecroscopicoService = useExameNecroscopicoService()
  const exameRealizadoService = useExameRealizadoService()
  const cadaverService = useCadaverService()

  const [processando, setProcessando] = useState(false)
  const [activeStep, setActiveStep] = useState(0)
  const steps = getSteps()
  const [operationDone, setOperationDone] = useState(false)
  const [lesoesForm, setLesoesForm] = useState([])
  const [cicatrizesForm, setCicatrizesForm] = useState([])
  const [sVGTatuagensForm, setSVGTatuagensForm] = useState({})
  const [svgLesoesForm, setSvgLesoesForm] = useState({})
  const [hideNextButton, setHideNextButton] = useState(false)


  console.log('SVG TATUAGENS')
  console.log(sVGTatuagensForm)

  console.log('SVG LESÕES')
  console.log(svgLesoesForm)

  const caracteristicasForm = useFormState(schemaCaracteristicas, {
    altura: '',
    peso: '',
    vestimentaSuperior: null,
    outraVestimentaSuperior: null,
    corVestimentaSuperior: null,
    vestimentaInferior: null,
    corVestimentaInferior: null,
    outraVestimentaInferior: null,
    tipoCalcado: null,
    outroTipoCalcado: null,
  })

  const conclusaoForm = useFormState(
    {},
    {
      examesSubsidiarios: '',
      causaMorte: null,
      conclusao: '',
      outraCausaMorte: '',
    }
  )

  const quesitosForm = useFormState({})

  useEffect(() => {
    if (operationDone) {
      setActiveStep((prevStep) => prevStep + 1)
    }
  }, [operationDone])

  useEffect(() => {
    if (exameNecroscopico && exameNecroscopico.id) {
      caracteristicasForm.setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          ...exameNecroscopico,
        },
      }))
    }
  }, [exameNecroscopico])

  const getStepTitle = () => {
    switch (activeStep) {
      case 0:
        return 'Características'
      case 1:
        return 'Tatuagens e Cicatrizes'
      case 2:
        return 'Fenômenos cadavéricos presentes no cadáver'
      case 3:
        return 'Lesões'
      case 4:
        return 'Análises Internas'
      case 5:
        return 'Discussão e Conclusão'
      case 6:
        return 'Quesitos'
      default:
        return ''
    }
  }

  const formError = () => {
    let disabled = false
    if (activeStep === 5) {
      if (!conclusaoForm.formState.values.causaMorte) {
        disabled = true
      }
      if (conclusaoForm.formState.values.causaMorte?.nome?.toUpperCase() === 'OUTRO' && !conclusaoForm.formState.values.causaMorteTextoLivre?.length) {
        disabled = true
      }
    }
    return disabled
  }

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1)
  }

  const handleNext = async () => {
    const cadaverId = exameNecroscopico?.exReal?.exSol?.cadavs?.[0]?.id

    if (activeStep === 0) {
      setOperationDone(false)
      await exameNecroscopicoService.editarExameNecroscopico(exameNecroscopico.id, caracteristicasForm.formState.values, setProcessando)
      await exameNecroscopicoService.listarExameNecroscopicoDadosFormulario(exameNecroscopico.id, setExameNecroscopico, setProcessando)
      setOperationDone(true)
    }

    if (activeStep === 1) {
      if (cadaverId) {
        await cadaverService.setarCicatrizesCadaver(cadaverId, exameNecroscopico.id, cicatrizesForm, setProcessando)
      }
      setActiveStep((prevStep) => prevStep + 1)
    }

    if (activeStep === 2) {
      setActiveStep((prevStep) => prevStep + 1)
    }

    if (activeStep === 3) {
      if (cadaverId) {
        await cadaverService.setarLesoesCadaver(cadaverId, exameNecroscopico.id, lesoesForm, setProcessando)
      }
      setActiveStep((prevStep) => prevStep + 1)
    }

    if (activeStep === 4) {
      setActiveStep((prevStep) => prevStep + 1)
    }

    if (activeStep === 5) {
      setOperationDone(false)
      await exameNecroscopicoService.editarConclusao(exameNecroscopico.id, conclusaoForm.formState.values, setProcessando)
      await exameNecroscopicoService.listarExameNecroscopicoDadosFormulario(exameNecroscopico.id, setExameNecroscopico, setProcessando)
      if (cadaverId) {
        await cadaverService.definirCausaMorte(cadaverId, conclusaoForm.formState.values.causaMorte?.id || null, conclusaoForm.formState.values.causaMorteTextoLivre || null)
      }
      setOperationDone(true)
    }

    if (activeStep === 6) {
      await exameNecroscopicoService.setarSVGS(exameNecroscopico.id, sVGTatuagensForm, svgLesoesForm, setProcessando)
      await exameRealizadoService.responderQuesitosEGerarDocumento(exameNecroscopico.id, quesitosForm.formState.values, setProcessando)
    }
  }

  return {
    processando,
    activeStep,
    steps,
    lesoesForm,
    setLesoesForm,
    cicatrizesForm,
    setCicatrizesForm,
    sVGTatuagensForm,
    setSVGTatuagensForm,
    svgLesoesForm,
    setSvgLesoesForm,
    hideNextButton,
    setHideNextButton,
    caracteristicasForm,
    conclusaoForm,
    quesitosForm,
    getStepTitle,
    formError,
    handleBack,
    handleNext,
    router,
  }
}
